import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type FC, type ReactNode, useState } from 'react';
import { AuthModalProvider } from './AuthModalProvider';
import { CartProvider } from './CartProvider';
import { FavoritesProvider } from './FavoritesProvider';

export const Providers: FC<{ children: ReactNode }> = ({ children }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 5 * 60 * 1000, refetchOnWindowFocus: false, retry: 1 },
        },
      }),
  );
  return (
    <QueryClientProvider client={queryClient}>
      <AuthModalProvider>
        <FavoritesProvider>
          <CartProvider>{children}</CartProvider>
        </FavoritesProvider>
      </AuthModalProvider>
    </QueryClientProvider>
  );
};

export { useAuthModal } from './AuthModalProvider';
export { useCart } from './CartProvider';
export { useFavorites } from './FavoritesProvider';
